var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import LottieButton from '../components/LottieButton';
import * as React from "react";
import * as _ from "lodash";
import { styled, useThemePart } from "../theme/ThemeHelpers";
import { lightenColor, getColor } from '../helpers/ColorHelpers';
import Icon from './Icon';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: ", ";\n    height:1.4285em;\n    padding:0;\n    width: ", ";\n    cursor: pointer;\n"], ["\n    display: ", ";\n    height:1.4285em;\n    padding:0;\n    width: ", ";\n    cursor: pointer;\n"])), function (p) { return p.block ? "block" : "inline-block"; }, function (p) { return p.block ? "100%" : "auto"; });
var RadioButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    float:left;\n    margin-top:-0.25em;\n    margin-right:5px;\n    height:1.4285em;\n"], ["\n    float:left;\n    margin-top:-0.25em;\n    margin-right:5px;\n    height:1.4285em;\n"])));
var LabelContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    line-height:1.4285em;\n    font-weight:500;\n    //color:", ";\n    color: ", ";\n    cursor: pointer;\n"], ["\n    display: inline-block;\n    line-height:1.4285em;\n    font-weight:500;\n    //color:", ";\n    color: ", ";\n    cursor: pointer;\n"])), function (props) { return lightenColor(props, props.theme.colors.darkGrey, 50); }, function (p) { return getColor(p, p.theme.color); });
var RadioButton = function (p) {
    var _a, _b;
    var onClick = p.onClick, selected = p.selected, block = p.block, label = p.label, rest = __rest(p, ["onClick", "selected", "block", "label"]);
    var radioButton = useThemePart(function (t) { return t.radioButton; });
    var naIcon = selected ? (_a = radioButton.notAnimatedIcon) === null || _a === void 0 ? void 0 : _a.selected : (_b = radioButton.notAnimatedIcon) === null || _b === void 0 ? void 0 : _b.notSelected;
    return (React.createElement(Container, { onClick: onClick, block: block !== null && block !== void 0 ? block : false },
        React.createElement(RadioButtonContainer, null, radioButton.notAnimated ?
            React.createElement(Icon, __assign({ name: selected ? "circle dot" : "circle", marginTop: 4, style: { float: "left", marginRight: 5 } }, naIcon))
            :
                React.createElement(LottieButton, __assign({}, rest, { kind: "fullTransparentButton", selected: selected, lottie: {
                        speed: 4,
                        url: "./images/lottiIcons/radiobutton.json",
                        behaviour: "PlayOnClickToggleDirection",
                        padding: "2px 3px 3px 2px"
                    }, size: "mini" }))),
        React.createElement(LabelContainer, null, label)));
};
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.setActive = function (i) {
            // console.log(i);
            var active = _this.state.active;
            active = active !== i ? i : undefined;
            _this.setState({ active: active });
        };
        _this.state = {};
        return _this;
    }
    RadioGroup.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var active = this.state.active;
        var filtered = _.isArray(props.children) ? _.filter(props.children, function (c) {
            if (c)
                return true;
            return false;
        }) : undefined;
        return (React.createElement("div", null, props.children && React.Children.map(filtered, function (c, i) {
            var selected = i === active;
            var tmp = c;
            if (tmp.type.name === "RadioButton")
                return React.cloneElement(c, { onClick: function () { return _this.setActive(i); }, selected: selected, ingroup: true });
            else
                return c;
        })));
    };
    return RadioGroup;
}(React.Component));
export { RadioGroup };
export default RadioButton;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=RadioButton.js.map